import { Toast } from 'drywall';
import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

// Push the close button to the far right
var closeButtonCSS = function closeButtonCSS(props) {
  var closeButton = props.closeButton;
  if (!closeButton) {
    return '';
  }
  return token({
    marginRight: 'Banner.withCloseButton.actionBodyMarginRight',
    marginLeft: 'Banner.withCloseButton.actionBodyMarginLeft'
  }, function (_ref) {
    var marginRight = _ref.marginRight,
      _ref$marginLeft = _ref.marginLeft,
      marginLeft = _ref$marginLeft === void 0 ? 0 : _ref$marginLeft;
    return css(["", "{margin-left:auto;}", ",", "{margin-right:", ";margin-left:", "px;}", "{margin-left:auto;}"], Toast.Icon, Toast.Action, Toast.Body, marginRight ? marginRight + "px" : spaceMixin('sm')(props), marginLeft, Toast.Close);
  })(props);
};

/** @class BannerMixin */
/** @method */
export var BannerMixin = function BannerMixin(props) {
  return token({
    borderRadius: "Banner.borderRadius",
    boxShadow: "Banner.boxShadow"
  }, function (_ref2) {
    var borderRadius = _ref2.borderRadius,
      boxShadow = _ref2.boxShadow;
    return css(["display:flex;max-width:none;border-radius:", ";box-shadow:", ";justify-content:center;", ""], borderRadius || 0, boxShadow || 'none', closeButtonCSS(props));
  })(props);
};